/* eslint-disable */
import React from 'react';
import { Box, Grid, IconButton, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import deleteIcon from 'Images/delete_icon.svg';
import SectionCard from './SectionCard';
import { StyledField, StyledSelect } from './helpers';

const CONTACT_TYPES = ['Whatsapp/Appel', 'Téléphone'];

const getValueFieldConfig = (type) => {
  if (type === 'Email') return { label: 'Email:', type: 'email', placeholder: 'exemple@email.com' };
  if (type === 'Téléphone') return { label: 'Téléphone:', type: 'tel', placeholder: '06XXXXXXXX' };
  if (type === 'Whatsapp/Appel') return { label: 'Whatsapp/Appel:', type: 'tel', placeholder: '06XXXXXXXX' };
  return { label: 'Téléphone:', type: 'tel', placeholder: '' };
};

const ContactSection = ({ contacts, onChangeContact, onAddContact, onDeleteContact }) => (
  <SectionCard
    id="contact"
    title="Contact"
    subtitle="Ajoutez ou modifiez vos coordonnées de contact"
  >
    {contacts.map((c) => {
      const fieldCfg = getValueFieldConfig(c.type);
      return (
        <Grid container spacing={2} key={c.id} alignItems="center" sx={{ mb: '12px' }}>
          <Grid item xs>
            <StyledField
              label="Nom et prénom"
              value={c.nom}
              onChange={(e) => onChangeContact(c.id, 'nom', e.target.value)}
            />
          </Grid>
          <Grid item xs>
            <StyledSelect
              label="Type"
              value={c.type}
              onChange={(e) => onChangeContact(c.id, 'type', e.target.value)}
              options={CONTACT_TYPES}
            />
          </Grid>
          <Grid item xs>
            <StyledField
              label={fieldCfg.label}
              type={fieldCfg.type}
              placeholder={fieldCfg.placeholder}
              value={c.telephone}
              onChange={(e) => onChangeContact(c.id, 'telephone', e.target.value)}
            />
          </Grid>
          <Grid item xs="auto">
            <IconButton
              onClick={() => onDeleteContact(c.id)}
              sx={{ mt: '2px', '&:hover img': { filter: 'brightness(0) saturate(100%) invert(29%) sepia(89%) saturate(876%) hue-rotate(182deg) brightness(100%) contrast(101%)' } }}
            >
              <img src={deleteIcon} alt="delete" style={{ width: 20, height: 20, objectFit: 'contain' }} />
            </IconButton>
          </Grid>
        </Grid>
      );
    })}

    <Box
      onClick={onAddContact}
      sx={{
        mt: '8px',
        border: '1px dashed #D1D5DB',
        borderRadius: '8px',
        py: '10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '6px',
        cursor: 'pointer',
        color: '#8398AE',
        transition: 'all 0.15s',
        '&:hover': { borderColor: '#007BC6', color: '#007BC6' },
      }}
    >
      <AddIcon sx={{ fontSize: 18 }} />
      <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>Ajouter Un Contact</Typography>
    </Box>
  </SectionCard>
);

export default ContactSection;
